import { render } from "./clapdetail.vue?vue&type=template&id=b9c83d96&scoped=true&ts=true"
import script from "./clapdetail.vue?vue&type=script&lang=ts"
export * from "./clapdetail.vue?vue&type=script&lang=ts"

import "./clapdetail.vue?vue&type=style&index=0&id=b9c83d96&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9c83d96"]])

export default __exports__